export default {
    title: 'Upgrade membership',
    headerText: 'Choose the payment way you want to use to upgrade your membership',
    success: 'Payment successful, redirecting...'
}
